import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useLang } from "../../context/LangContext";
import styles from "./Navbar.module.css";

function useIsMobile(breakpoint = 768) {
  const [mobile, setMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false,
  );
  useEffect(() => {
    const fn = () => setMobile(window.innerWidth <= breakpoint);
    window.addEventListener("resize", fn, { passive: true });
    return () => window.removeEventListener("resize", fn);
  }, [breakpoint]);
  return mobile;
}

function Navbar() {
  const { t, lang, setLang } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const isMobile = useIsMobile();
  const location = useLocation();

  // Close drawer on navigation
  useEffect(() => setMobileOpen(false), [location]);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const isLight = scrolled || mobileOpen;

  const navLinks = [
    { label: lang === "tr" ? "Ana Sayfa" : "Home", href: "/#hero" },
    { label: lang === "tr" ? "Özellikler" : "Features", href: "/#features" },
    {
      label: lang === "tr" ? "Nasıl Çalışır" : "How It Works",
      href: "/#how-it-works",
    },
    { label: lang === "tr" ? "Fiyatlar" : "Pricing", href: "/#pricing" },
    { label: lang === "tr" ? "SSS" : "FAQ", href: "/#faq" },
    { label: lang === "tr" ? "Hakkımızda" : "About", href: "/about" },
  ];

  const ctaLabel = lang === "tr" ? "Uygulamayı İndir" : "Download App";

  return (
    <nav className={`${styles.nav} ${isLight ? styles.navScrolled : ""}`}>
      <div className={styles.inner}>
        {/* ── Brand ─────────────────────────────────────── */}
        <a href="/#hero" className={styles.brand}>
          <div className={styles.brandIcon}>B</div>
          <span className={styles.brandName}>BITAKAS</span>
        </a>

        {/* ── Desktop links ──────────────────────────────── */}
        {!isMobile && (
          <div className={styles.desktopLinks}>
            {navLinks.map((l, i) => (
              <a key={i} href={l.href} className={styles.navLink}>
                {l.label}
              </a>
            ))}
            <button
              className={styles.langBtn}
              onClick={() => setLang(lang === "en" ? "tr" : "en")}
            >
              {lang === "en" ? "🇹🇷 TR" : "🇬🇧 EN"}
            </button>
            <a href="/#download" className={styles.ctaBtn}>
              {ctaLabel}
            </a>
          </div>
        )}

        {/* ── Mobile: lang + hamburger ───────────────────── */}
        {isMobile && (
          <div className={styles.mobileActions}>
            <button
              className={styles.langBtn}
              onClick={() => setLang(lang === "en" ? "tr" : "en")}
            >
              {lang === "en" ? "🇹🇷" : "🇬🇧"}
            </button>
            <button
              className={styles.hamburger}
              onClick={() => setMobileOpen((o) => !o)}
              aria-label="Toggle menu"
              aria-expanded={mobileOpen}
            >
              <span
                className={`${styles.bar} ${mobileOpen ? styles.bar1Open : ""}`}
              />
              <span
                className={`${styles.bar} ${mobileOpen ? styles.barHide : ""}`}
              />
              <span
                className={`${styles.bar} ${mobileOpen ? styles.bar3Open : ""}`}
              />
            </button>
          </div>
        )}
      </div>

      {/* ── Mobile drawer ──────────────────────────────────── */}
      {isMobile && (
        <div
          className={`${styles.drawer} ${mobileOpen ? styles.drawerOpen : ""}`}
        >
          {navLinks.map((l, i) => (
            <a
              key={i}
              href={l.href}
              className={styles.drawerLink}
              onClick={() => setMobileOpen(false)}
            >
              {l.label}
            </a>
          ))}

          <a
            href="/#download"
            className={styles.drawerCta}
            onClick={() => setMobileOpen(false)}
          >
            {ctaLabel}
          </a>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
